import styled from 'styled-components'
import { orange, laranja, white } from '../../../styles/colors'
import { device } from '../../../styles/breakpoints'
import { Link } from 'gatsby'

export const Section = styled.section`
  background-color: ${laranja.terra};
  padding: 40px 0 40px 0;
  background-image: url('https://central-imagens.bancointer.com.br/a6559724/rules-sm.webp');
  background-size: 97%;
  background-position: 100% 33%;
  background-repeat: no-repeat;

  @media (max-width: 320px) {
    background-position: 95% 36%;
    background-size: 95%;
  }

  @media (min-width: 321px) and (max-width: 375px) {
    background-position: 95% 35%;
    background-size: 94%;
  }

  @media ${device.tablet} {
    padding: 60px 0 60px 0;
    background-image: url('https://central-imagens.bancointer.com.br/664457ab/rule-of-50-md.webp');
    background-size: 47%;
    background-position: right 210px;
  }

  @media ${device.desktopLG} {
    height: 664px;
    padding: 64px 0 64px 0;
    background-image: none;
  }

  @media ${device.desktopXL} {
    height: 849px;
    padding: 96px 0 96px 0;
  }

  @media ${device.desktopXXL} {
    height: 815px;
    padding: 140px 0 120px 0;
  }

  .margin-text {
    margin-top: 310px;

    @media (max-width: 320px) {
      margin-top: 240px;
    }

    @media (min-width: 321px) and (max-width: 375px) {
      margin-top: 280px;
    }

    @media ${device.tablet} {
      margin-top: 24px;
    }
`

export const Title = styled.h2`
  font-size: 24px;
  line-height: 28px;
  font-weight: 500;
  color: ${white};
  font-family: 'Citrina', sans-serif;
  margin-bottom: 16px;

  @media ${device.tablet} {
    line-height: 30px;
    font-size: 28px;
  }

  @media ${device.desktopLG} {
    font-size: 32px;
    line-height: 38px;
  }

  @media ${device.desktopXL} {
    font-size: 48px;
    line-height: 52px;
  }
`

export const Description = styled.p`
  font-size: 16px;
  line-height: 22px;
  font-weight: 400;
  color: white;

  @media ${device.tablet} {
    font-size: 20px;
    margin-bottom: 36px;
  }

  @media ${device.desktopXL} {
    font-size: 24px;
    line-height: 26px;
  }
`

export const ListTitle = styled.p`
  font-size: 14px;
  line-height: 22px;
  font-weight: 700;
  color: ${white};
  margin-bottom: 16px;

  @media ${device.tablet} {
    font-size: 16px;
    margin-bottom: 24px;
  }

  @media ${device.desktopXL} {
    font-size: 20px;
    margin-bottom: 24px;
  }
`

export const ListDescription = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  color: ${white};
  margin-left: 16px;
  margin-bottom: 0;

  @media ${device.desktopLG} {
    font-size: 16px;
    line-height: 24px;
  }

  @media ${device.desktopXL} {
    font-size: 18px;
  }
`

export const Paragraph = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${white};

  @media ${device.tablet} {
    font-size: 16px;
    margin-bottom: 24px;
  }

  @media ${device.desktopLG} {
    font-size: 16px;
    margin-top: 24px;
    margin-bottom: 24px;
  }

  @media ${device.desktopXL} {
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 32px;
  }
`

export const ContentItems = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  margin-left: 16px;
  display: flex;
  align-items: baseline;

  @media ${device.tablet} {
    margin-bottom: 16px;
    margin-left: 16px;
  }

  @media ${device.desktopXL} {
    margin-left: 24px;
  }
`

export const Btn = styled(Link)`
  width: 100%;
  height: 48px;
  background: ${orange.default};
  border-radius: 8px;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  color: ${white};
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${device.tablet} {
    width: 355px;
  }

  @media ${device.desktopLG} {
    width: 455px;
  }

  &:focus, &:hover {
    background: ${orange.default};
    outline: none;
    text-decoration: none;
    color: ${white};
    opacity: 0.9;
  }
`
